import React, {useState} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {ValueType} from "react-select";
import Address from "../../../../Models/Address";
import City from "../../../../Models/City";
import Zone from "../../../../Models/Zone";
import {RootState} from "../../../../Store/Reducers";
import {AddressActions} from "../../../../Store/Address/Slice";
import {ModalActions} from "../../../../Store/Modal/Slice";
import {ADDRESS_MODAL} from "../../../../Store/Modal/Types";
import {getModalTitle} from "../../../../Utils/Utils";
import ModalFooterWithButtons from "../../ModalFooterWithButtonsComponent";
import AddressFormComponent from "./AddressFormComponent";
import {Customer} from "../../../../Models/Customer";

interface IAddress {
  address_city: string;
  address_zone: string;
  address_neighborhood: string;
  address_address: string;
  address_building: string;
  address_interior: string;
  address_notallow: boolean;
}

const toIAddress = (address: Address) :IAddress => {
  return  {
    address_city: (address.city as City)?._KEY || address.city as string,
    address_zone: (address.zone as Zone)?._KEY || address.zone as string,
    address_neighborhood: address.neighborhood,
    address_address: address.address,
    address_building: address.building,
    address_interior: address.interior,
    address_notallow: address.notallow,
  }
}

const AddressModalComponent = () => {

  const {
    ModalReducer : {addressModal},
    LoadingReducer : {loadingSaveAddress},
    CompanyReducer: {branch_selected, company_selected}
  } = useSelector((state: RootState) => state);

  const { formType, model } = addressModal?.data;

  const clientId = model?.customer || model;
  const address = (typeof model === "string" ? {}: model) as Address;

  const form = useForm<IAddress>({ defaultValues: toIAddress(address) });
  const { handleSubmit } = form;

  const dispatch = useDispatch();
  const [disableSave, setDisableSave] = useState<boolean>();

  const onSubmit: SubmitHandler<IAddress> = (data: IAddress) => {
    const params: Address = {
      _KEY: address._KEY,
      address: data.address_address,
      city: (data.address_city as ValueType<any>).value,
      zone: data.address_zone ? (data.address_zone as ValueType<any>).value : undefined,
      neighborhood: data.address_neighborhood,
      building: data.address_building,
      interior: data.address_interior,
      notallow: data.address_notallow,
      customer: (branch_selected as Customer)?._KEY || (company_selected as Customer)?._KEY || clientId,
    };
    setDisableSave(true);
    dispatch(AddressActions.saveAddress(params));
  }

  const onClose = () => {
    dispatch(ModalActions.closeModal({
      modal: ADDRESS_MODAL
    }));
  }

  return (
    <Modal
      isOpen={addressModal.open}
      size="lg"
    >
      <ModalHeader>{getModalTitle(formType, "Dirección")}</ModalHeader>
      <ModalBody>
        <FormProvider {...form}>
          <AddressFormComponent
            address={address}
            formType={formType}
          />
        </FormProvider>
      </ModalBody>
      <ModalFooterWithButtons
        onSave={handleSubmit(onSubmit)}
        onClose={onClose}
        disabledSave={disableSave}
        isLoading={loadingSaveAddress.status.isLoading()}
      />
    </Modal>
  );
};
export default AddressModalComponent;
